/*
  Sent/List.js - Component to generate the list of Sent SMS items
*/

// NPM
import React, { useState } from 'react';
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
} from '@mui/material';

import { FormattedMessage } from 'react-intl';
// COMPONENTS
import AllMessagesTableRow from './AllMessagesTableRow';

// CONFIG
import config from '../../../Config';

const AllMessagesTable = ({ list, showSingleSentSms, clickToFilter }) => {
  const [pageNumber, setPageNumber] = useState(1);
  const pageLength = config.defaultPL;

  /*
    Handles the change event when clicking a pagination number
  */
  const changeEvent = (i) => {
    setPageNumber(i + 1);
  };

  const generateTableBody = () => {
    return list.map((element) => (
      <AllMessagesTableRow
        key={element.sms_id}
        id={element.sms_id}
        date={element.date}
        delivered={element.delivered}
        user={element.user}
        from={element.from}
        to={element.to}
        country={element.country}
        status={element.status}
        errorCode={element.errorCode}
        parameters={`${element.parts} / ${element.chars} / ${element.encoding}`}
        duration={element.duration}
        onClickMessage={(e) => showSingleSentSms(e)}
        clickToFilter={(name, value) => clickToFilter(name, value)}
        sentSms={element}
      />
    ));
  };

  return (
    <TableContainer
      sx={{
        marginBottom: 4,
        overflowX: 'auto',
        width: '100%',
        whiteSpace: 'nowrap',
      }}>
      <Table id="inbox">
        <TableHead>
          <TableRow>
            <TableCell>
              <FormattedMessage
                id="Websms.DateTimeText"
                defaultMessage="Date/Time"
              />
            </TableCell>
            <TableCell>
              <FormattedMessage id="Websms.User" defaultMessage="User" />
            </TableCell>
            <TableCell>
              <FormattedMessage id="websms.FromText" defaultMessage="From" />
            </TableCell>
            <TableCell>
              <FormattedMessage id="Websms.ToText" defaultMessage="To" />
            </TableCell>
            <TableCell>
              <FormattedMessage id="Websms.country" defaultMessage="Country" />
            </TableCell>
            <TableCell>
              <FormattedMessage id="Websms.Status" defaultMessage="Status" />
            </TableCell>
            <TableCell>
              <FormattedMessage
                id="Websms.ErrorCode"
                defaultMessage="ErrorCode"
              />
            </TableCell>
            <TableCell>
              <FormattedMessage
                id="Websms.Parameters"
                defaultMessage="Parameters"
              />
            </TableCell>
            <TableCell>
              <FormattedMessage
                id="Websms.Duration"
                defaultMessage="Duration (ms)"
              />
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>{generateTableBody()}</TableBody>
      </Table>
    </TableContainer>
  );
};

export default AllMessagesTable;
